import { apiFetch } from '../client';

/** "Tus solicitudes" de las Alertas de Inicio. Server: server/src/routes/alertas.ts. */
export type Resolucion = {
  /** '<tipo>:<id>' — lo que se guarda al descartarla. */
  key: string;
  tipo: string;
  resultado: 'Aprobado' | 'Rechazado';
  detalle: string;
  motivo: string | null;
  ventaId: number | null;
  cliente: string | null;
  resueltoAt: string;
};

export async function listResoluciones(): Promise<Resolucion[]> {
  const r = await apiFetch<{ items: Resolucion[] }>('/api/alertas/resoluciones');
  return r.items;
}

export async function descartarAlertas(keys: string[]): Promise<void> {
  await apiFetch('/api/alertas/descartar', { method: 'POST', body: { keys } });
}

/** E-cheq rechazado por el banco con el horno ya despachado (admin/administración). */
export type EcheqRebotado = {
  key: string;
  nroCheque: string;
  banco: string;
  monto: number;
  motivo: string | null;
  ventaId: number;
  cliente: string | null;
  ventaStatus: string;
  rechazadoAt: string;
};

export async function listEcheqsRebotados(): Promise<EcheqRebotado[]> {
  const r = await apiFetch<{ items: EcheqRebotado[] }>('/api/alertas/echeqs-rebotados');
  return r.items;
}
